import { createReducer, on, Action } from '@ngrx/store';
import { Details } from '@details/Interfaces/details';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import * as Actions from '../actions/arrears-listing-widget.actions';
import { ITable } from '@common/models/table';
import {Currency} from '@currency/models/currency.model';

export class ArrearsListingWidgetInstance {
  id: number;
  table: ITable;
  loading: boolean;
  currency?: Currency;
}

export const adapter: EntityAdapter<ArrearsListingWidgetInstance> = createEntityAdapter<ArrearsListingWidgetInstance>();

export interface State extends EntityState<ArrearsListingWidgetInstance>{};

export const initialState: State = adapter.getInitialState();

const arrearsListingWidgetReducer = createReducer(
  initialState,

  on(Actions.loadArrearsTable, (state, { dashboardWidgetId }) => {
    const instance: ArrearsListingWidgetInstance = { id: dashboardWidgetId, loading: true, table: undefined };
    return adapter.upsertOne(instance, state);
  }),

  on(Actions.loadArrearsTableComplete, (state, { dashboardWidgetId, table }) => {
    const instance: ArrearsListingWidgetInstance = { id: dashboardWidgetId, loading: false, table };
    return adapter.upsertOne(instance, state);
  }),



  on(Actions.loadArrearsTenantTableComplete, (state, { dashboardWidgetId, table }) => {
    const instance: ArrearsListingWidgetInstance = { id: dashboardWidgetId, loading: false, table };
    return adapter.upsertOne(instance, state);
  })
);

export function reducer(state: State | undefined, action: Action) {
  return arrearsListingWidgetReducer(state, action);
}
